import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreon } from 'storeon/react';
import { Section, SectionSubTitle } from 'common/components';
import { RELATED_SERVICES_STORE_NAME, selectActualMeasure } from 'modules/related-services';
import { CardContent, SizingInstruction } from './components';

/**
 * Вью секции замера
 */
export const SizingSection: React.FC = () => {
  const { relatedServices } = useStoreon(RELATED_SERVICES_STORE_NAME);
  const actualMeasure = selectActualMeasure(relatedServices);
  const { t } = useTranslation();

  const Content = useMemo(() => {
    if (actualMeasure) {
      return <CardContent actualMeasure={actualMeasure} />;
    }

    return <SizingInstruction />;
  }, [actualMeasure]);

  return (
    <Section>
      <SectionSubTitle adaptiveMargin margin="s">
        {t('sizing-section.title')}
      </SectionSubTitle>
      {Content}
    </Section>
  );
};
